import { render, staticRenderFns } from "./createUserName.vue?vue&type=template&id=7e1089b2&"
import script from "./createUserName.vue?vue&type=script&lang=js&"
export * from "./createUserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/createUserName.vue"
export default component.exports